import SettingsPage from "./page/SettingsPage";
import { ToastProvider } from "../../context/ToastContext";
import { SettingsContextProvider } from "../../context/SettingsContext";
import ToastContainer from "../../components/Toast/ToastContainer";
import PreviewWindow from "./PreviewWindow";

const SettingsApp = () => {
    return (
        <>
            <ToastProvider>
                <SettingsContextProvider>
                    <SettingsPage />
                    <ToastContainer />
                    <PreviewWindow />
                </SettingsContextProvider>
            </ToastProvider>
        </>
    );
};

export default SettingsApp;
